export const liveChatGroupMap = {
  pro: '1',
  integrations: '2',
  support: '3',
  studio: '4',
};

export type LiveChatGroup = keyof typeof liveChatGroupMap;
